class ExecuteCommandTypes {
	static InvalidEvent = 0;
	static EndShow = 1;
	static RainDelayStart = 2;
	static RainDelayEnd = 3;
	static ModeChange = 4;
	static SyndicationOriginationStart = 5;
	static SyndicationOriginationEnd = 6;
}

export default ExecuteCommandTypes;